import { lazy, ReactElement } from 'react';
import Login from '../public/Login';
import PrivateRoute from './PrivateRoute';
import Page404 from '../layout/Page404/Page404';
import { Roles } from '../../utils/constants';

const Dashboard = lazy(() => import('../layout/Dashboard'));
const Users = lazy(() => import('../layout/Users'));
const UserInfo = lazy(() => import('../layout/UserInfo/UserInfo'));
const NPCbyBrand = lazy(() => import('../reports/NPCbyBrand/NpcByBrand'));
const NPCbyItem = lazy(() => import('../reports/NPCbyItem/NpcByItem'));
const NPCStorage = lazy(() => import('../reports/NpcStorage/NpcStorage'));
const NpcInboundFreight = lazy(
  () => import('../reports/NpcInboundFreight/NpcInboundFreight')
);
const NpcFbaFreight = lazy(
  () => import('../reports/NpcFbaFreight/NpcFbaFreight')
);
const FbaFreightBrand = lazy(
  () => import('../reports/NpcFbaFreight/FbaFreightBrand/FbaFreightBrand')
);
const Warehouse = lazy(() => import('../reports/Warehouse/Warehouse'));
const Itemlookup = lazy(() => import('../reports/Itemlookup/Itemlookup'));

interface RouteElement {
  path: string;
  element: ReactElement<any, any>;
}

export const routeConfig: RouteElement[] = [
  {
    path: '/',
    element: <Login />
  },
  {
    path: '/dashboard/',
    element: <PrivateRoute component={Dashboard} />
  },
  {
    path: '/users/',
    element: <PrivateRoute component={Users} access={[Roles.ADMIN]} />
  },
  {
    path: '/userinfo/',
    element: <PrivateRoute component={UserInfo} />
  },
  {
    path: '/npc/bybrand/',
    element: (
      <PrivateRoute
        component={NPCbyBrand}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/npc/byitem/',
    element: (
      <PrivateRoute
        component={NPCbyItem}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/npc/storage/',
    element: (
      <PrivateRoute
        component={NPCStorage}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/npc/inboundFreight/',
    element: (
      <PrivateRoute
        component={NpcInboundFreight}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/npc/fbafreight/',
    element: (
      <PrivateRoute
        component={NpcFbaFreight}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/npc/fbafreight/:brandId',
    element: (
      <PrivateRoute
        component={FbaFreightBrand}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/warehouse/:name',
    element: (
      <PrivateRoute
        component={Warehouse}
        access={[Roles.ADMIN, Roles.SUPPORT]}
      />
    )
  },
  {
    path: '/itemlookup/',
    element: <PrivateRoute component={Itemlookup} />
  },
  {
    path: '*',
    element: <Page404 />
  }
];
